import axios from "axios";
import Cookie from "js-cookie";

const OTHER_FIELDS_CODES = {
  start_time: 2,
  start_place: 3,
  start_city: 4,
  transfer_cost: 5,
  transfer_type: 6,
  insrance_cost: 7,
  transfer_name: 8,
  weather: 9,
  sim_cost: 10,
  trip_type: 11,
  essentials: 12,
};

const DAILY_CODE = {
  10: 2,
  11: 3,
  12: 4,
  15: 7,
  16: 6,
  17: 5,
  18: 10,
  19: 8,
};

const TABLES_CODES = {
  fixedCosts: {
    1: 201,
    2: 202,
    3: 203,
    4: 204,
    5: 205,
    6: 206,
    7: 207,
    8: 208,
    9: 209,
    10: 210,
    11: 211,
  },
  estimate: {
    1: 31,
    2: 32,
    3: 33,
    4: 34,
    5: 35,
    6: 36,
    7: 37,
    8: 38,
    // add 1 to the end for estimate and 2 for capacity
    // except 2, 3, 5, 8
  },
  other: {
    1: 11,
    2: 12,
    3: 13,
    4: 14,
    5: 15,
    6: 16,
    7: 17,
    8: 18,
    9: 19,
    // add 1 to the end for nafar, 2 for tedad, 3 for gheimatVahed and 4 for gheimatKol
    // except 9
  },
};

async function connection(url, keyValues, cover_pic = -1) {
  let formData = new FormData();
  if (cover_pic != -1) {
    if (Object.keys(keyValues).includes("cover_pic"))
      delete keyValues.cover_pic;
    formData.append("cover_pic", cover_pic);
  }
  for (let key in keyValues) {
    formData.append(key, keyValues[key]);
  }
  formData.append("usertoken", Cookie.get("token"));
  return await axios
    .post(`http://mvc.dade24.ir/api/${url}`, formData)
    .then((res) => {
      if (typeof res.data.status !== "undefined" && !Boolean(res.data.status)) {
        console.log("url", url);
        console.log("keyValues", keyValues);
      }
      return res.data;
    });
}

function setData(data, keys) {
  return keys.reduce((total, value) => {
    total[value] = data[value];
    return total;
  }, {});
}

function setUpdateData(data) {
  return Object.keys(data).reduce((total, value, index) => {
    if (index != 0) {
      return (total += "@@" + value + "," + data[value]);
    }
    return (total += value + "," + data[value]);
  }, "");
}

async function getOtherFields(tour_id, code) {
  return await connection("Find_tour_other_field_values", {
    fields: "code, val",
    conditions: `tour_id/=/${tour_id}@@code/in/${code.join(",")}`,
  });
}

function getOtherFieldsArray(data) {
  return Object.keys(data).reduce((total, value) => {
    return [
      ...total,
      {
        code: OTHER_FIELDS_CODES[value],
        val: data[value],
      },
    ];
  }, []);
}

async function updateOtherFields(tour_id, data) {
  let flag = true;
  await Promise.all(
    data.map(async (value) => {
      let res = await connection("Update_tour_other_field_values", {
        keyvalues: `val, ${value.val}`,
        conditions: `tour_id/=/${tour_id}@@code/=/${value.code}`,
      });
      flag = Boolean(res.status) ? flag : false;
    })
  );
  return flag;
}

//get static data
async function getLeaders() {
  return await connection("Find_users", {
    fields: "id, fname, lname",
    conditions: "isadmin/=/1@@user_admin_group/=/2@@mainstatus/!=/2",
  });
}

async function getTourTags() {
  return await connection("Find_tour_tags", {
    fields: "id, title",
  });
}

async function getAttractions() {
  return await connection("Find_attractions", {
    fields: "id, title",
  });
}

async function getEssentialsAccessories() {
  let res = await connection("Find_tours", {
    fields: "essentials_accessories",
  });
  res = res.reduce((total, value) => {
    let arr = value.essentials_accessories.split("+");
    arr = arr.reduce((t, v) => {
      v = v.trim();
      if (
        total.some((val) => val == v) ||
        t.some((val) => val == v) ||
        v == ""
      ) {
        return t;
      }
      return [...t, v];
    }, []);
    return [...total, ...arr];
  }, []);
  return res;
}

async function getCities() {
  return await connection("Find_cities", {});
}

async function getUserTags() {
  return await connection("Find_user_tags", { fields: "id, title" });
}

// get dynamic data
async function getTourDetails(tour_id) {
  let data,
    res = {
      id: tour_id,
      title: "",
      cityid: 0,
      mainprice: 0,
      cover_pic: "",
      stm: 0,
      ftm: 0,
      hardshiplevel: 0,
      visa: 0,
      insurance: 0,
      tourleaderuid: 0,
      isspecial: 0,
      essentials_accessories: [],
      attractions: [],
      tour_tags: [],
      trip_type: "",
      essentials: "",
    };
  data = await connection("Find_tours", {
    fields:
      "title, cityid, cover_pic, mainprice, stm, ftm, hardshiplevel, visa, insurance, tourleaderuid, isspecial, essentials_accessories, main_status",
    conditions: `id/=/${tour_id}`,
  });
  data = data[0];
  res = { id: tour_id, ...data };
  res.title = data.title;
  res.cityid = data.cityid;
  res.cover_pic = `http://mvc.dade24.ir/${
    data.cover_pic.trim() != "" && data.cover_pic.trim() != "undefined"
      ? data.cover_pic
      : "uploads/28620211007-120240.854e02c4.png"
  }`;
  res.mainprice = data.mainprice;
  res.stm = parseInt(data.stm) * 1000;
  res.ftm = parseInt(data.ftm) * 1000;
  res.hardshiplevel = data.hardshiplevel;
  res.main_status = data.main_status;
  res.visa = data.visa;
  res.insurance = data.insurance;
  res.tourleaderuid = data.tourleaderuid;
  res.isspecial = data.isspecial;
  res.essentials_accessories = data.essentials_accessories.split("+");
  data = await connection("Find_tour_Attraction_links", {
    fields: "tour_attraction_id",
    conditions: `tour_id/=/${tour_id}`,
  });
  res.attractions = data;
  data = await connection("Find_tour_tags_links", {
    fields: "tour_tag_id",
    conditions: `tour_id/=/${tour_id}`,
  });
  res.tour_tags = data;
  data = await getOtherFields(tour_id, [11, 12]);
  let temp = data.find((value) => value.code == 11);
  if (typeof temp !== "undefined") res.trip_type = temp.val;
  temp = data.find((value) => value.code == 12);
  if (typeof temp !== "undefined") res.essentials = temp.val;
  return res;
}

async function getAdditionalCost(tour_id) {
  return await connection("Find_tour_additional_cost", {
    fields: "id, title, description, cost, tour_id",
    conditions: `tour_id/=/${tour_id}`,
  });
}

async function getReservePrograms(tour_id) {
  let data = await connection("Find_tour_reservation_programs", {
    fields: "id, stm, ftm, user_tag_id, prepay, tour_id",
    conditions: `tour_id/=/${tour_id}`,
  });
  return data.map((value) => {
    value.stm = parseInt(value.stm) * 1000;
    value.ftm = parseInt(value.ftm) * 1000;
    return value;
  });
}

async function getDailyInfo(tour_id) {
  let code = [2, 3, 4, 5, 6, 7, 8, 9, 10],
    data = [
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "0",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "1",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "3",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noeEghamat: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
        {
          title: " زمان",
          datepick: 0,
          id: 10,
          status: false,
          isPublic: true,
        },
        {
          title: " محل",
          name: "",
          id: 11,
          status: false,
          isPublic: true,
        },
        {
          title: " مبدا",
          name: "",
          id: 12,
        },
        {
          title: "ظرفیت",
          name: "",
          id: 13,
          status: false,
          isPublic: true,
        },
        {
          title: "نمایشی",
          name: "",
          id: 14,
          status: false,
          isPublic: true,
        },
        {
          title: " بیمه",
          price: 0,
          id: 15,
          status: false,
          isPublic: true,
        },
        {
          title: " ترنسفر",
          name: "",
          value: "",
          trans: "",
          id: 16,
          status: false,
          isPublic: true,
        },
        {
          title: " ترنسفر قیمت",
          price: 0,
          id: 17,
          status: false,
          isPublic: true,
        },
        {
          title: " سیم کارت",
          price: 0,
          id: 18,
          status: false,
          isPublic: true,
        },
        {
          title: "نام ترنسفر",
          name: "",
          value: "",
          trans: "",
          id: 19,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: "هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: 0,
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: 0,
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: 0,
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: 0,
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
    ],
    temp;
  temp = await connection("Find_tours", {
    fields: "main_capacity, public_capacity",
    conditions: `id/=/${tour_id}`,
  });
  data[0] = data[0].map((value) => {
    if (value.id == 13) {
      value.name = temp[0].main_capacity;
    } else if (value.id == 14) {
      value.name = temp[0].public_capacity;
    }
    return value;
  });
  temp = await connection("Find_tour_other_field_values", {
    fields: "code, val",
    conditions: `tour_id/=/${tour_id}@@code/in/${code.join(",")}`,
  });
  let weather = [];
  temp.forEach((value) => {
    if (value.code == 9) {
      weather = value.val.split("+");
      return;
    }
    switch (parseInt(value.code)) {
      case 2:
        data[0] = data[0].map((val) => {
          if (val.id == 10) {
            val.datepick = parseInt(value.val) * 1000;
            val.isPublic = value.ispublic == 1;
          }
          return val;
        });
        break;
      case 3:
        data[0] = data[0].map((val) => {
          if (val.id == 11) {
            val.name = value.val;
            val.isPublic = value.ispublic == 1;
          }
          return val;
        });
        break;
      case 4:
        data[0] = data[0].map((val) => {
          if (val.id == 12) {
            val.name = value.val;
            val.isPublic = value.ispublic == 1;
          }
          return val;
        });
        break;
      case 5:
        data[0] = data[0].map((val) => {
          if (val.id == 17) {
            val.price = value.val;
            val.isPublic = value.ispublic == 1;
          }
          return val;
        });
        break;
      case 6:
        data[0] = data[0].map((val) => {
          if (val.id == 16) {
            val.trans = value.val;
            val.isPublic = value.ispublic == 1;
          }
          return val;
        });
        break;
      case 7:
        data[0] = data[0].map((val) => {
          if (val.id == 15) {
            val.price = value.val;
            val.isPublic = value.ispublic == 1;
          }
          return val;
        });
        break;
      case 8:
        data[0] = data[0].map((val) => {
          if (val.id == 19) {
            val.trans = value.val;
            val.isPublic = value.ispublic == 1;
          }
          return val;
        });
        break;
      case 10:
        data[0] = data[0].map((val) => {
          if (val.id == 18) {
            val.price = value.val;
            val.isPublic = value.ispublic == 1;
          }
          return val;
        });
        break;
      default:
        console.log("Error");
    }
  });
  temp = await connection("Find_tour_Daily_schedule", {
    conditions: `tour_id/=/${tour_id}`,
  });
  for (let i = 0; i < 10; i++) {
    let t = temp.filter((value) => value.daynum == i);
    t.forEach((value) => {
      switch (parseInt(value.type)) {
        case 1:
          data[i] = data[i].map((val) => {
            if (val.id == 0) {
              val.onvan = value.title;
              val.description = value.description;
              val.price = value.pre_price;
              val.status = true;
            }
            return val;
          });
          break;
        case 3:
          data[i] = data[i].map((val) => {
            if (val.id == 4) {
              val.onvan = value.title;
              val.description = value.description;
              val.price = value.pre_price;
              val.status = true;
            }
            return val;
          });
          break;
        case 6:
          data[i] = data[i].map((val) => {
            if (val.id == 7) {
              val.onvan = value.title;
              val.description = value.description;
              val.price = value.pre_price;
              val.status = true;
            }
            return val;
          });
          break;
        case 0:
          data[i] = data[i].map((val) => {
            if (val.id == 1) {
              val.resturan = value.Account_side_name;
              val.tel = value.Account_side_tell;
              val.address = value.Account_side_address;
              val.foodName = value.foodname;
              val.price = value.pre_price;
              val.status = true;
            }
            return val;
          });
          break;
        case 2:
          data[i] = data[i].map((val) => {
            if (val.id == 2) {
              val.resturan = value.Account_side_name;
              val.tel = value.Account_side_tell;
              val.address = value.Account_side_address;
              val.foodName = value.foodname;
              val.price = value.pre_price;
              val.status = true;
            }
            return val;
          });
          break;
        case 5:
          data[i] = data[i].map((val) => {
            if (val.id == 5) {
              val.resturan = value.Account_side_name;
              val.tel = value.Account_side_tell;
              val.address = value.Account_side_address;
              val.foodName = value.foodname;
              val.price = value.pre_price;
              val.status = true;
            }
            return val;
          });
          break;
        case 4:
          data[i] = data[i].map((val) => {
            if (val.id == 3) {
              val.onvan = value.foodname;
              val.price = value.pre_price;
              val.status = true;
            }
            return val;
          });
          break;
        case 7:
          data[i] = data[i].map((val) => {
            if (val.id == 6) {
              val.onvan = value.Account_side_name;
              val.tel = value.Account_side_tell;
              val.address = value.Account_side_address;
              val.noeEghamat = value.val;
              val.price = value.pre_price;
              val.status = true;
            }
            return val;
          });
          break;
        case 8:
          let tt =
            value.other_item != ""
              ? JSON.parse(value.other_item)
              : { vehValue: "", capacity: "", noe: "" };
          data[i] = data[i].map((val) => {
            if (val.id == 8) {
              return {
                ...val,
                ...tt,
                vehValue: tt.vehValue,
                capacity: tt.capacity,
                price: value.pre_price,
                status: true,
              };
            }
            return val;
          });
          break;
        default:
          console.log(value.id);
      }
    });
    if (i < weather.length && weather[i] != "") {
      data[i] = data[i].map((value) => {
        if (value.id == 9) {
          value.weather = weather[i];
          value.status = true;
        }
        return value;
      });
    }
  }
  return data;
}

async function getTables(tour_id) {
  let data = [
      [
        {
          name: "هزینه ترنسفر",
          fixedCosts: 0,
          nextRun: 0,
          id: 1,
        },
        {
          name: "هزینه های ثابت راننده و لیدر",
          fixedCosts: 0,
          nextRun: 0,
          id: 2,
        },
        {
          name: "هزینه اقامتگاه در حالت دربستی",
          fixedCosts: 0,
          nextRun: 0,
          id: 3,
        },
        {
          name: "موسیقی محلی و سورپرایز",
          fixedCosts: 0,
          nextRun: 0,
          id: 4,
        },
        {
          name: "وروذی های اتوبوس",
          fixedCosts: 0,
          nextRun: 0,
          id: 5,
        },
        {
          name: "وروذی های اتوبوس",
          fixedCosts: 0,
          nextRun: 0,
          id: 6,
        },
        {
          name: "هزینه تبلیغات",
          fixedCosts: 0,
          nextRun: 0,
          id: 7,
        },
        {
          name: "پورسانت کل کانتر فروش",
          fixedCosts: 0,
          nextRun: 0,
          id: 8,
        },
        {
          name: "مجموعه هزینه های ثابت",
          fixedCosts: 0,
          nextRun: 0,
          id: 9,
        },
        {
          name: "هزینه های پیش بینی نشد",
          fixedCosts: 0,
          nextRun: 0,
          id: 10,
        },
        {
          name: "جمع نهایی",
          fixedCosts: 0,
          nextRun: 0,
          id: 11,
        },
      ],
      [
        {
          name: "هزینه ثابت",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 1,
        },
        {
          name: "هزینه های متغیر",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 2,
        },
        {
          name: "کمسیون آزانس",
          estimate: 0,
          nextRun: 0,
          id: 3,
        },
        {
          name: "هزینه نهایی",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 4,
        },
        {
          name: "قیمت فروش",
          estimate: 0,
          nextRun: 0,
          id: 5,
        },
        {
          name: "حاشیه سود",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 6,
        },
        {
          name: "براورد سود",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 7,
        },
        {
          name: "",
          estimate: 0,
          capacity: 0,
          id: 8,
        },
      ],
      [
        {
          name: "صبحانه",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 1,
        },
        {
          name: "ناهار",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 2,
        },
        {
          name: "شام",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 3,
        },
        {
          name: "اقامت",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 4,
        },
        {
          name: "ترنسفر اصلی لیدر",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 5,
        },
        {
          name: "ترنسفر کمکی لیدر",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 6,
        },
        {
          name: "دستمزد لیدر",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 7,
        },
        {
          name: "لیدر محلی",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 8,
        },
        {
          name: "جمع کل هزینه های ثابت",
          gheimatKol: 0,
          badeEjra: 0,
          id: 9,
        },
      ],
    ],
    temp;
  temp = await connection("Find_tour_other_field_values", {
    fields: "code, val",
    conditions: `tour_id/=/${tour_id}@@code/between/100, 400`,
  });
  // let temp = data.filter(value => value.code > 100 && value.code < 200);
  temp.forEach((record) => {
    let t = record.code.toString().split("");
    let id, index;
    switch (parseInt(t[0])) {
      case 1:
        id = parseInt(t[1]);
        index = parseInt(t[2]);
        data[2] = data[2].map((value) => {
          if (value.id == id) {
            if (index == 1) {
              value.nafar = record.val;
            } else if (index == 2) {
              value.tedad = record.val;
            } else if (index == 3) {
              value.gheimatVahed = record.val;
            } else {
              value.gheimatKol = record.val;
            }
          }
          return value;
        });
        break;
      case 2:
        id = parseInt(t[1] + t[2]);
        data[0] = data[0].map((value) => {
          if (value.id == id) {
            value.fixedCosts = record.val;
          }
          return value;
        });
        break;
      case 3:
        id = parseInt(t[1]);
        index = parseInt(t[2]);
        data[1] = data[1].map((value) => {
          if (value.id == id) {
            if (index == 1) {
              value.estimate = record.val;
            } else {
              value.capacity = record.val;
            }
          }
          return value;
        });
        break;
      default:
        console.log(record);
    }
  });
  return data;
}

// save data
async function saveTourDetails(info) {
  async function insert(data, cover_pic = -1) {
    let res = await connection("Insert_tours", data, cover_pic);
    if (Boolean(res.status)) {
      return res.result.id;
    }
    return res;
  }

  async function update(id, data, cover_pic = -1) {
    data = setUpdateData(data);
    data = {
      keyvalues: data,
      conditions: `id/=/${id}`,
    };
    let res = await connection("Update_tours", data, cover_pic);
    return res.status;
  }

  {
    let arrayOfKeys = [
      "city",
      "id",
      "title",
      "mainprice",
      "stm",
      "ftm",
      "hardshiplevel",
      "visa",
      "insurance",
      "tourleaderuid",
      "isspecial",
      "trip_type",
      "essentials",
      "tour_tags",
      "attractions",
      "essentials_accessories",
      "main_status",
    ];
    let arrayOfKeysInfo = Object.keys(info);
    let temp = [];
    if (
      arrayOfKeys.reduce((total, value) => {
        if (!arrayOfKeysInfo.includes(value)) {
          temp.push(value);
          return false;
        }
        return total;
      }, false)
    ) {
      return `missing ${temp.join(", ")}`;
    }
  }

  let res;
  // insert city if it doesn't exist
  if (info.city.id == -1) {
    res = await connection("Insert_cities", {
      title: info.city.title,
      provinceid: 1,
    });
    if (Boolean(res.status)) {
      info.city.id = res.result.id;
    } else {
      return false;
    }
  }
  // insert tour and get id
  let data = setData(info, [
    "title",
    "mainprice",
    "stm",
    "ftm",
    "hardshiplevel",
    "essentials_accessories",
    "visa",
    "insurance",
    "tourleaderuid",
    "isspecial",
    "main_status",
  ]);
  data.cityid = info.city.id;
  {
    let date = new Date();
    data.stm =
      data.stm != ""
        ? Math.floor(parseInt(data.stm) / 1000)
        : Math.floor(date.getTime() / 1000);
    data.ftm =
      data.ftm != ""
        ? Math.floor(parseInt(data.ftm) / 1000)
        : Math.floor(date.getTime() / 1000);
  }
  data.cover_pic = " ";
  if (
    typeof data.essentials_accessories === "object" &&
    data.essentials_accessories.length > 0
  ) {
    data.essentials_accessories = data.essentials_accessories.join("+");
  }
  let id;
  let date = new Date();
  date = Math.floor(date.getTime() / 1000);
  if (info.id == -1) {
    data.mtm = date;
    id = await insert(data, info.cover_pic);
  } else {
    id = info.id;
    data.uptm = date;
    await update(id, data, info.cover_pic);
  }
  if (id === false) return false;

  // insert or update other field values
  data = setData(info, ["trip_type", "essentials"]);
  let d;
  await getOtherFields(id, [11, 12]).then((res) => (d = res));
  let flag = true;
  if (d.length == 0) {
    let data1 = getOtherFieldsArray(data);
    data1[0].tour_id = id;
    data1[1].tour_id = id;
    res = await connection("Insert_tour_other_field_values", data1[0]);
    if (Boolean(res.status)) {
      flag = true;
    } else {
      flag = false;
    }
    res = await connection("Insert_tour_other_field_values", data1[1]);
    if (!Boolean(res.status)) {
      flag = false;
    }
  } else {
    data = getOtherFieldsArray(data);
    flag = await updateOtherFields(id, data);
  }
  if (!flag) return false;

  // insert tour tags if they don't exist, then insert tour tag links
  res = await connection("Delete_tour_tags_links", {
    conditions: `tour_id/=/${id}`,
  });
  flag = res.status != 1;
  if (flag) return false;

  data = await Promise.all(
    info.tour_tags.map(async (value) => {
      if (value.id != -1) {
        return value;
      }
      res = await connection("Insert_tour_tags", { title: value.title });
      if (Boolean(res.status)) {
        value.id = res.result.id;
      } else {
        flag = true;
      }
      return value;
    })
  );
  if (flag) return false;

  await Promise.all(
    data.map(async (value) => {
      res = await connection("Insert_tour_tags_links", {
        tour_tag_id: value.id,
        tour_id: id,
      });
      if (!Boolean(res.status)) {
        flag = true;
      }
    })
  );
  if (flag) return false;

  // insert attractions if they don't exist, then insert tour attractions links
  res = await connection("Delete_tour_Attraction_links", {
    conditions: `tour_id/=/${id}`,
  });
  if (res.status != 1) return false;
  data = await Promise.all(
    info.attractions.map(async (value) => {
      if (value.id != -1) {
        return value;
      }
      res = await connection("Insert_attractions", {
        title: value.title,
        cityid: 1,
      });
      if (res.status) {
        value.id = res.result.id;
      } else {
        flag = true;
      }
      return value;
    })
  );
  if (flag) return false;

  await Promise.all(
    data.map(async (value) => {
      res = await connection("Insert_tour_Attraction_links", {
        tour_attraction_id: value.id,
        tour_id: id,
      });
      if (!Boolean(res.status)) {
        flag = true;
      }
    })
  );
  return id;
}

async function saveAdditionalCost(tour_id, info) {
  async function insert(data) {
    let res = await connection("Insert_tour_additional_cost", data);
    if (!Boolean(res.status)) {
      return false;
    } else {
      return true;
    }
  }
  let res = await connection("Delete_tour_additional_cost", {
    conditions: `tour_id/=/${tour_id}`,
  });
  if (!Boolean(res.status)) {
    return false;
  }
  let flag = true;
  await Promise.all(
    info.map(async (value) => {
      flag = (await insert(value)) ? flag : false;
    })
  );
  return flag;
}

async function saveReservePrograms(tour_id, info) {
  async function insert(data) {
    let res = await connection("Insert_tour_reservation_programs", data);
    if (!Boolean(res.status)) {
      return false;
    } else {
      return true;
    }
  }
  let res = await connection("Delete_tour_reservation_programs", {
    conditions: `tour_id/=/${tour_id}`,
  });
  if (!Boolean(res.status)) {
    return false;
  }
  let flag = true;
  await Promise.all(
    info.map(async (value) => {
      value.stm = Math.floor(parseInt(value.stm) / 1000);
      value.ftm = Math.floor(parseInt(value.ftm) / 1000);
      flag = (await insert(value)) ? flag : false;
    })
  );
  return flag;
}

async function saveDailyInfo(tour_id, info) {
  let code = [2, 3, 4, 5, 6, 7, 8, 10],
    data;
  data = await connection("Delete_tour_other_field_values", {
    conditions: `tour_id/=/${tour_id}@@code/in/${[...code, 9].join(",")}`,
  });
  // let data = getOtherFields(tour_id, code);
  if (!data.status) return false;
  code = [10, 11, 12, 15, 16, 17, 18, 19];
  {
    let city = info[0].find((value) => value.id == 12);
    if (city) {
      if (city.name.id == -1) {
        let r = await connection("Insert_cities", {
          title: city.name.title,
        });
        if (!Boolean(r.status)) return false;
        city.name = r.result.id;
      } else {
        city.name = city.name.id;
      }
    }
  }
  console.log(info[0]);
  let d = info[0].reduce((total, value) => {
    if (!code.includes(value.id)) return total;
    let val;
    switch (value.id) {
      case 10:
        val =
          value.datepick != ""
            ? Math.floor(parseInt(value.datepick) / 1000)
            : "";
        break;
      case 11:
      case 12:
        val = value.name;
        break;
      case 15:
      case 17:
      case 18:
        val = value.price;
        break;
      case 16:
      case 19:
        val = value.trans;
        break;
      default:
        return total;
    }
    let temp = {
      code: DAILY_CODE[value.id],
      val,
    };
    return [...total, temp];
  }, []);
  let weather = info.reduce((total, value, index) => {
    let w = value.find((val) => val.id == 9);
    if (typeof w === "undefined") {
      console.log("Error for Weather!?");
      return total;
    }
    if (index == 0) return total + w.weather;
    return total + "+" + w.weather;
  }, "");
  d.push({ code: 9, val: weather });
  let flag = false;
  await Promise.all(
    d.map(async (value) => {
      let res = await connection("Insert_tour_other_field_values", {
        ...value,
        tour_id,
      });
      flag = res.status == 1 ? flag : true;
    })
  );
  if (flag) return false;

  flag = false;
  let main_capacity = info[0].find((value) => value.id == 13).name,
    public_capacity = info[0].find((value) => value.id == 14).name;
  data = setUpdateData({
    main_capacity,
    public_capacity,
  });
  let res = await connection("Update_tours", {
    keyvalues: data,
    conditions: `id/=/${tour_id}`,
  });
  if (!Boolean(res.status)) return false;

  flag = false;
  res = await connection("Delete_tour_Daily_schedule", {
    conditions: `tour_id/=/${tour_id}`,
  });
  if (!Boolean(res.status)) return false;
  code = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  flag = true;
  let allData = [];
  info.forEach((val, index) => {
    val.map((value) => {
      if (!code.includes(value.id) || !value.status) return;
      let temp = {
        tour_id,
        daynum: index,
        ispublic: value.isPublic,
      };
      switch (value.id) {
        case 0:
        case 4:
        case 7:
          temp = {
            ...temp,
            type: value.id == 0 ? 1 : value.id == 4 ? 3 : 6,
            title: value.onvan,
            description: value.description,
            pre_price: value.price,
          };
          break;
        case 1:
        case 2:
        case 5:
          temp = {
            ...temp,
            type: value.id == 1 ? 0 : value.id == 2 ? 2 : 5,
            Account_side_name: value.resturan,
            Account_side_tell: value.tel,
            Account_side_address: value.address,
            foodname: value.foodName,
            pre_price: value.price,
          };
          break;
        case 3:
          temp = {
            ...temp,
            type: 4,
            foodname: value.onvan,
            pre_price: value.price,
          };
          break;
        case 6:
          temp = {
            ...temp,
            type: 7,
            val: value.noeEghamat,
            Account_side_name: value.onvan,
            Account_side_tell: value.tel,
            Account_side_address: value.address,
            pre_price: value.price,
          };
          break;
        case 8:
          temp = {
            ...temp,
            type: 8,
            other_item: JSON.stringify({
              vehValue: value.vehValue,
              capacity: value.capacity,
              noe: value.noe[0].title,
            }),
            pre_price: value.price,
          };
          break;
        default:
          return;
      }
      allData.push(temp);
    });
  });
  await Promise.all(
    allData.map(async (value) => {
      let r = await connection("Insert_tour_Daily_schedule", value);
      flag = r.status ? flag : false;
    })
  );
  return flag;
}

async function saveTables(tour_id, info) {
  let insertData = [],
    updateData = [];
  let data = await connection("Find_tour_other_field_values", {
    fields: "code",
    conditions: `tour_id/=/${tour_id}@@code/between/100, 400`,
  });
  info.map((table) => {
    if (
      table.every((value) => {
        return Object.keys(value).includes("fixedCosts");
      })
    ) {
      let records = data.filter(
        (value) => value.code > 200 && value.code < 300
      );
      table.map((value) => {
        let theData = {
          code: TABLES_CODES.fixedCosts[value.id],
          val: value.fixedCosts,
        };

        let index = records.findIndex((v) => v.code == theData.code);
        if (index == -1) {
          // insert
          insertData.push(theData);
        } else {
          // update
          updateData.push(theData);
        }
      });
    } else if (
      table.some((value) => {
        return Object.keys(value).includes("estimate");
      })
    ) {
      let records = data.filter(
        (value) => value.code > 300 && value.code < 400
      );
      table.map((value) => {
        let row = TABLES_CODES.estimate[value.id],
          theData = { code: parseInt(`${row}1`), val: value.estimate };

        let index = records.findIndex((v) => v.code == theData.code);
        if (index == -1) {
          // insert
          insertData.push(theData);
        } else {
          // update
          updateData.push(theData);
        }

        if (![2, 3, 5, 8].includes(value.id)) {
          theData = {
            code: parseInt(`${row}2`),
            val: value.capacity,
          };

          index = records.findIndex((v) => v.code == theData.code);
          if (index == -1) {
            // insert
            insertData.push(theData);
          } else {
            // update
            updateData.push(theData);
          }
        }
      });
    } else {
      let records = data.filter(
        (value) => value.code > 100 && value.code < 200
      );
      table.map((value) => {
        let row = TABLES_CODES.other[value.id],
          theData = {
            code: parseInt(`${row}4`),
            val: value.gheimatKol,
          };

        let index = records.findIndex((v) => v.code == theData.code);
        if (index == -1) {
          // insert
          insertData.push(theData);
        } else {
          // update
          updateData.push(theData);
        }
        if (value.id != 9) {
          theData = { code: parseInt(`${row}1`), val: value.nafar };
          index = records.findIndex((v) => v.code == theData.code);
          if (index == -1) {
            // insert
            insertData.push(theData);
          } else {
            // update
            updateData.push(theData);
          }

          theData = { code: parseInt(`${row}2`), val: value.tedad };
          index = records.findIndex((v) => v.code == theData.code);
          if (index == -1) {
            // insert
            insertData.push(theData);
          } else {
            // update
            updateData.push(theData);
          }

          theData = { code: parseInt(`${row}3`), val: value.gheimatVahed };
          index = records.findIndex((v) => v.code == theData.code);
          if (index == -1) {
            // insert
            insertData.push(theData);
          } else {
            // update
            updateData.push(theData);
          }
        }
      });
    }
  });
  let flag = true;
  if (insertData.length > 0) {
    await Promise.all(
      insertData.map(async (value) => {
        {
          let res = await connection("Insert_tour_other_field_values", {
            tour_id,
            code: value.code,
            val: value.val,
          });
          if (!Boolean(res.status)) flag = false;
        }
      })
    );
  }
  if (flag && updateData.length > 0) {
    flag = (await updateOtherFields(tour_id, updateData)) ? flag : false;
  }
  return flag;
}

export {
  // get static data
  getLeaders,
  getTourTags,
  getAttractions,
  getEssentialsAccessories,
  getCities,
  getUserTags,
  // get dynamic data
  getTourDetails,
  getAdditionalCost,
  getReservePrograms,
  getDailyInfo,
  getTables,
  // save data
  saveTourDetails,
  saveAdditionalCost,
  saveReservePrograms,
  saveDailyInfo,
  saveTables,
};
